import {DatasetDataInfoResponse} from "api/apiModels";
import {ChronoUnit} from "utils/time-utils";
import {ReportOptions} from "./component-print-models";
import {Dashboard} from "components/pages/dashboard/components/interfaces";
import IComponentBaseProps = Dashboard.IComponentBaseProps;
import IComponentTimed = Dashboard.IComponentTimed;

export type DatasetDataInfo = DatasetDataInfoResponse & {
    loadedTime: Date
}

export interface DatasetFullDefaultConfig extends IComponentBaseProps<ReportOptions>, IComponentTimed {
    config?: ComponentConfigDefault;
    datasets?: Array<DatasetDefaultConfig>;
}


export interface TimeConfigDefaultDefined {
    alignStartTo: ChronoUnit,
    startOffsetUnits: ChronoUnit,
    startOffset: number,
    lagUnits: ChronoUnit,
    lagOffset: number,
    leadUnits: ChronoUnit,
    leadOffset: number
}

export interface ComponentConfigDefault {
    alignStartTo?: ChronoUnit,
    startOffsetUnits?: ChronoUnit,
    startOffset?: number,
    lagUnits?: ChronoUnit,
    lagOffset?: number,
    leadUnits?: ChronoUnit,
    leadOffset?: number,

    stepUnits?: ChronoUnit,
    stepSize?: number,

    startAutoRefreshFrequency?: number

    dateFormat?: ChronoUnit;

    sort?: "ASC" | "DESC";

    itemsPerPage?: number;
    transposed?:boolean

    hideDateColumn?: boolean;
}

export interface DatasetDefaultConfig {
    overriddenTitle?: string;
    description?: string;
    identifier: string;
    decimalPlaces?: number;
}

export interface DatasetOverrideTitleConfig {
    overriddenTitle?: String;
    description?: String;
    title: String;
    unit?: String;
}

export interface MeasurementDataResponse {
    meterId: string;
    timeStart: number;
    timeEnd: number;
    value: number;
    unit: string;
}

export interface IPair {
    key: string;
    value: any;
}

export const mapDatasetDataInfoResponseToDatasetDataInfo = (dataset: DatasetDataInfoResponse) => {
    return {...dataset, loadedTime: new Date()} as DatasetDataInfo
}